export const Plus = `
<path fill-rule="evenodd" clip-rule="evenodd" d="M512 1024C794.77 1024 1024 794.77 1024 512C1024 229.23 794.77 0 512 0C229.23 0 0 229.23 0 512C0 794.77 229.23 1024 512 1024Z"/>
<rect x="490.667" y="362.667" width="42.6667" height="298.667" fill="white"/>
<rect x="661.333" y="490.667" width="42.6667" height="298.667" transform="rotate(90 661.333 490.667)" fill="white"/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/plus.js